<template>
  <section class="section-shaped mt-5 mb-3 py-3">
  	<div class="container">
  		<v-wait for="dublador.profile.load" transition="fade" :duration="750"> 
  			<template slot="waiting">
  				<div class="col">
  					<div class="ph-col-5 mt-3 mb-5"></div>
  					<div class="ph-container">
  						<div class="ph-col-8 mb-2"></div><div class="ph-col-1 empty mb-2"></div><div class="ph-col-3 mb-2"></div>
  						<div class="ph-col-8 mb-2"></div><div class="ph-col-1 empty mb-2"></div><div class="ph-col-3 mb-2"></div>
  					</div>
  				</div>
  			</template>
  		<div id="biografia" v-if="dublador.descricao">
  			<h3 class="display-3">Biografia</h3>
  			<div v-html="dublador.descricao"></div>
  		</div>
  		</v-wait>
  	</div>
  </section>
</template>
<script>
export default {
  name: 'dubladorBiografia',
  computed: {
    dublador() {
      return this.$store.state.catalog.person;
    }
  }
};
</script>
